import { CellContext } from '@tanstack/react-table'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { UserPersonalSkillsTableRow } from '../data'
import profileSkillIcon from 'app/packs/images/icons/profile-skill.svg'

export const NameCell = observer(
  (data: CellContext<UserPersonalSkillsTableRow, unknown>) => {
    const row = data.row.original
    const isInferred = row.source === 'implied'

    return (
      <div className="flex gap-x-3 items-center">
        <div
          className="flex-shrink-0 h-8 w-8 rounded"
          style={{
            background: `url("${profileSkillIcon}") center/cover no-repeat`,
          }}
        />
        <span className="font-semibold text-gray-900 text-sm">{row.name}</span>
        {isInferred && (
          <span className="inline-flex items-center h-[20px] text-xs text-orange-700 bg-orange-100 px-2 py-0.5 rounded">
            Inferred
          </span>
        )}
      </div>
    )
  }
)
